import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import * as XLSX from 'xlsx';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
//import DeleteIcon from '@mui/icons-material/Delete';
//import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, fetchData1 } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select


function PRReport1() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [data1, setData1] = useState([]);
    const [deleteMember, setDeleteMember] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [memberid, setMemberId] = useState(0);
    const [type, settype] = useState(3);
    const [from, setFromDate] = useState("");
    const [to, setToDate] = useState("");
    const history = useHistory(); // Access the navigation history
    const [memberlist, setMemberOptions] = useState([]);
    const { isAuthenticated, clubId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [selectedMembers, setSelectedMembers] = useState({});
    const [selectedMember, setSelectedMember] = useState(""); // Store selected member ID
    const [memberList, setMemberList] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            //fetchMember();

            logout();
            return;
        }

        // Token is not expired, fetch data


    }, [isAuthenticated, clubId, branchId, token, logout]);

    useEffect(() => {
        const currentDate = new Date();
        // Set 'to' as current date
        const to = currentDate.toISOString().split("T")[0]; // Formats the date as YYYY-MM-DD
        setToDate(to);
        const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

        // Extract day, month, and year
        const day = String(firstDayOfMonth.getDate()).padStart(2, '0'); // Ensure 2-digit day
        const month = String(firstDayOfMonth.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
        const year = firstDayOfMonth.getFullYear();

        // Format as DD-MM-YYYY
        const formattedDate = `${year}-${month}-${day}`;

        setFromDate(formattedDate);


    }, []);
    const fetchtableData = async () => {
        try {

            const response = await fetchData1('ReportsApi', `/${clubId}/${branchId}/${from}/${to}/${memberid}/${4}`, token);

            if (response.responseCode === '1111') {
                console.log('Fetched Data:', response);
                setData(response.response_data.paymentData);
                setData1(response.response_data.receiptData);
            } else {
                console.warn('Response indicates an issue:', response);
            }
        } catch (error) {
            if (error.response) {
                console.error('Server Error:', error.response.data);
                console.error('Status Code:', error.response.status);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Unexpected Error:', error.message);
            }
        }
    };

    const handleMemberSelectChange = (selectedOption) => {
        setSelectedMembers(selectedOption.value);
    };
    const handleFormSubmit = (e) => {
        e.preventDefault();
        fetchtableData();
    }
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setIsModalOpen(true); // Open modal when typing in the search box
    };
    const handleRowClick = (member) => {
        const selectedOption = { value: member.id, label: `${member.firstName} ${member.lastName}` };
        setSelectedMember(selectedOption);
        setSearchTerm(selectedOption.label); // Display the selected name in the search box
        setIsModalOpen(false); // Close modal after selecting a member
        setMemberId(selectedOption.value);
    };
    const formatDateForInput = (dateString) => {
        if (!dateString) return ''; // Handle cases where dateString is undefined or null
        const currentDate = new Date(dateString);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const filteredMembers = memberList.filter((member) =>
        `${member.firstName} ${member.lastName}`.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleExportExcel = () => {
        const excelData = [];
        let copbal = 0; // Cumulative opening balance for credit
        let dopbal = 0; // Cumulative opening balance for debit
        let bal = 0;    // Running balance

        // Helper function to compute balance
        const computeBalance = (data) => {
            // if (data.description1 === 'Opening Balance') {
            //     bal = 0; // Reset balance for opening balance
            // } else 
            if (data.description !== 'Closing Balance' && data.description !== 'Total') {
                // Add debit to balance
                if (data.debit) {
                    bal += Math.abs(data.debit);
                }
                // Subtract credit from balance
                if (data.credit) {
                    bal -= Math.abs(data.credit);
                }
            }

            // Return balance string with "Dr" or "Cr"
            //data.description1 !== 'Opening Balance' &&
            if (data.description !== 'Closing Balance' && data.description !== 'Total') {
                return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
            }
            return '';
        };

        // Ensure selectedCustomer is handled properly
        const customerLabel = "";//= selectedChildOption ? selectedChildOption.label : 'Cash Book';

        // Add header caption
        const headerCaption = [
            [`Cash Book From: ${formatDate(from)} To: ${formatDate(to)}`]
        ];
        excelData.push(...headerCaption);

        // Add column headers
        const headerRow = ['Date', 'Description', 'Debit', 'Credit', 'Balance'];
        excelData.push(headerRow);

        // Add data rows
        data.forEach((rowData) => {
            const dataRow = [];
            if (rowData.description === 'Opening Balance') {
                // Display balances under Debit and Credit columns
                dataRow.push(
                    '', // Empty date
                    rowData.description,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    computeBalance(rowData)
                );

            } else if (rowData.description === 'Closing Balance') {
                // Display Total directly under Debit and Credit columns
                dataRow.push(
                    '', // Empty date
                    rowData.description,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    '' // No balance for Total rows
                );
            }

            else if (rowData.description === 'Total') {
                // Display Total directly under Debit and Credit columns
                dataRow.push(
                    '', // Empty date
                    rowData.description,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    '' // No balance for Total rows
                );
            } else {
                // For regular rows
                dataRow.push(
                    formatDate(rowData.date1), // Format the date
                    rowData.description,
                    rowData.debit != null ? parseFloat(rowData.debit.toFixed(2)) : '',
                    rowData.credit != null ? parseFloat(rowData.credit.toFixed(2)) : '',
                    computeBalance(rowData) // Compute and add balance
                );
            }
            excelData.push(dataRow);
        });

        // Create a worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(excelData);

        // Style the worksheet to right-align specific columns
        const columnIndexesToRightAlign = [2, 3, 4]; // Debit, Credit, and Balance columns
        const range = XLSX.utils.decode_range(worksheet['!ref']);

        for (let row = 1; row <= range.e.r; row++) { // Start from row 1 (skip header)
            columnIndexesToRightAlign.forEach((colIndex) => {
                const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
                if (worksheet[cellAddress]) {
                    worksheet[cellAddress].s = { alignment: { horizontal: 'right' } };
                }
            });
        }

        // Create workbook and add the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Cash Book');

        // Filename sanitization for spaces and special characters
        const sanitizedCustomerLabel = customerLabel.replace(/[^\w]/g, '_');
        XLSX.writeFile(workbook, `Cash_Book_From_${formatDate(from).replace(/[/]/g, '-')}_To_${formatDate(to).replace(/[/]/g, '-')}.xlsx`);
    };
    let copbal = 0; // Cumulative opening balance for credit
    let dopbal = 0; // Cumulative opening balance for debit
    let bal = 0;    // Running balance

    const computeBalance = (data) => {
        // Compute balance logic
        // if (data.description1 === 'Opening Balance') {
        //     bal = 0; // Reset balance for opening balance
        // } else 
        if (data.description !== 'Closing Balance' && data.description !== 'Total') {
            // Add debit to balance
            if (data.debit) {
                bal += Math.abs(data.debit);
            }
            // Subtract credit from balance
            if (data.credit) {
                bal -= Math.abs(data.credit);
            }
        }

        // Return balance string with "Dr" or "Cr"
        if (data.description !== 'Closing Balance' && data.description !== 'Total') {
            return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
        }
        return '';
    };
    useEffect(() => {
        fetchtableData();
        // fetchtableData1();
    }, [memberid]);

    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <div className="w-full mb-2 flex" style={{ marginTop: '10px', justifyContent: 'space-between' }}>

                <h6 className='productHead flex-grow linkcolor' style={{ color: '#0e728c', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#0e728c' }}> PAYMENT & RECEIPT REPORT</h6>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', marginLeft: '10px', flexWrap: 'wrap' }}>

                    {/* From Date Field */}
                    <div style={{ display: 'flex', alignItems: 'center', paddingRight: '8px', marginBottom: '10px' }}>
                        <label
                            style={{ color: 'Black', fontSize: '14px', fontWeight: 'bold', marginRight: '8px' }}
                            htmlFor="fromDate"
                        >
                            From
                        </label>
                        <input
                            id="fromDate"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date"
                            value={from}
                            onChange={(e) => setFromDate(e.target.value)}
                        />
                    </div>

                    {/* To Date Field */}
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '8px', marginBottom: '10px' }}>
                        <label
                            style={{ color: 'Black', fontSize: '14px', fontWeight: 'bold', marginRight: '8px' }}
                            htmlFor="toDate"
                        >
                            To
                        </label>
                        <input
                            id="toDate"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="date"
                            value={to}
                            onChange={(e) => setToDate(e.target.value)}
                        />
                    </div>
                </div>
                <Button
                    // style={{ marginLeft: '8px', color: 'darkgreen' }}
                    style={{
                        background: 'linear-gradient(to right, #4D455D,#4D455D)',
                        color: 'black',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        //marginLeft: '5px',
                        marginLeft: '15px',
                        marginTop: '1.0%'

                    }}
                    onClick={handleFormSubmit}

                >
                    <RefreshIcon style={{ color: 'white', fontWeight: 'bolder' }} />
                    <b style={{ color: 'white' }}>Refresh</b>
                </Button>

                {/*<Button
                    // style={{ marginLeft: '8px', color: 'darkgreen' }}
                    style={{
                        background: 'linear-gradient(to right, #4D455D,#4D455D)',
                        color: 'black',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        //marginLeft: '5px',
                        marginLeft: '15px',
                        marginTop: '1.0%'

                    }}
                    onClick={handleExportExcel}

                >
                    <FeedIcon style={{ color: 'white', fontWeight: 'bolder' }} />
                    <b style={{ color: 'white' }}>Excel</b>
                </Button>*/}
            </div>
            <div className='w-full mb-5 flex' style={{ maxHeight: '510px', overflowY: 'auto' }}>

                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#336D82', padding: '5px' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#336D82', padding: '5px', color: 'whitesmoke', textTransform: 'uppercase', fontSize: '12px' }}>Receipt Head</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', textAlign: 'right', backgroundColor: '#336D82', padding: '5px', color: 'whitesmoke', textTransform: 'uppercase', fontSize: '12px' }}>Receipt Amount</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#336D82', padding: '5px', color: 'whitesmoke', textTransform: 'uppercase', fontSize: '12px' }}>Payment Head</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', textAlign: 'right', color: 'whitesmoke', borderRight: '2px solid #ccc', backgroundColor: '#336D82', padding: '5px', textTransform: 'uppercase', fontSize: '12px' }}>
                                    Payment Amount
                                </TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.from({ length: Math.max(data.length, data1.length) }).map((_, index) => {
                                const incomeItem = data[index] && data[index].paymentHead !== "Total" ? data[index] : null;
                                const expenseItem = data1[index] && data1[index].receiptHead !== "Total" ? data1[index] : null;

                                return (
                                    <TableRow key={index}>

                                        <TableCell sx={{ padding: '6px' }}>{expenseItem ? expenseItem.receiptHead : ''}</TableCell>
                                        <TableCell sx={{ textAlign: 'right', borderRight: '2px solid #ccc', padding: '6px' }}>
                                            {expenseItem && expenseItem.receiptAmount != null ? expenseItem.receiptAmount.toFixed(2) : ''}
                                        </TableCell>
                                        <TableCell sx={{ padding: '6px' }}>{incomeItem ? incomeItem.paymentHead : ''}</TableCell>
                                        <TableCell sx={{ textAlign: 'right', padding: '5px' }}>
                                            {incomeItem && incomeItem.paymentAmount != null ? incomeItem.paymentAmount.toFixed(2) : ''}
                                        </TableCell>

                                    </TableRow>
                                );
                            })}
                            {/* Total Row */}
                            <TableRow sx={{ backgroundColor: '#F2F2F2', fontWeight: 'bold' }}>
                                <TableCell sx={{ fontWeight: 'bold', padding: '10px' }}>Total</TableCell>
                                <TableCell sx={{ textAlign: 'right', padding: '10px', fontWeight: 'bold', borderRight: '2px solid #ccc' }}>



                                    {data1
                                        .filter(item => item.receiptHead !== "Total")
                                        .reduce((sum, item) => sum + (item.receiptAmount || 0), 0)
                                        .toFixed(2)}


                                </TableCell>
                                <TableCell sx={{ fontWeight: 'bold', padding: '10px' }}>Total</TableCell>
                                <TableCell sx={{ textAlign: 'right', padding: '10px', fontWeight: 'bold' }}>

                                    {data
                                        .filter(item => item.paymentHead !== "Total")
                                        .reduce((sum, item) => sum + (item.paymentAmount || 0), 0)
                                        .toFixed(2)}


                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>
        </div >
    );
}

export default PRReport1;
